import { HTMLMotionProps, Target, TargetAndTransition } from 'motion/react';

type Opts = {
  initial?: Target;
  animate?: TargetAndTransition;
  exit?: TargetAndTransition;
};

type MotionDivProps = HTMLMotionProps<'div'> & {
  ref?: React.Ref<HTMLDivElement>;
};

/**
 * Add a slide in/out animation to a motion div.
 */
export const slideVertical = (options: Opts = {}): MotionDivProps => {
  const { initial = {}, animate = {}, exit = { transition: {} } } = options;
  return {
    animate: {
      translateY: 0,
      opacity: 1,
      ...animate,
    },
    initial: {
      translateY: -10,
      opacity: 0,
      ...initial,
    },
    exit: {
      translateY: -10,
      opacity: 0,
      ...exit,
      transition: { ease: 'easeInOut', ...(exit.transition || {}) },
    },
  };
};
